'use client';

import React, { useEffect } from 'react';
import { Button } from '@components/ui/button';
import * as Sentry from '@sentry/nextjs';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
          <div className="max-w-md w-full text-center">
            <div className="mb-8">
              <h1 className="text-4xl font-bold text-destructive">Oops!</h1>
              <p className="text-xl text-muted-foreground">Something went really wrong</p>
            </div>

            <div className="mb-8">
              <p className="text-muted-foreground mb-4">
                We&apos;re experiencing technical difficulties. Our team has been notified and is working to fix this
                issue.
              </p>

              {process.env.NODE_ENV === 'development' && (
                <div className="bg-muted p-4 rounded-lg text-left mb-4">
                  <p className="text-sm font-semibold mb-2">Error Details (Development):</p>
                  <code className="text-xs break-words">{error.message}</code>
                  {error.digest && <p className="text-xs text-muted-foreground mt-2">Error ID: {error.digest}</p>}
                </div>
              )}
            </div>

            <div className="space-y-4">
              <Button onClick={reset} className="w-full">
                Try again
              </Button>

              <Button variant="outline" className="w-full" onClick={() => (window.location.href = '/')}>
                Go to homepage
              </Button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
